<template>
  <div class="eventosCompactos">
    <div v-if="idCopiado !== ''" class="eventoCompactoAviso">
      <strong>Id copiado</strong>
      <span>{{ idCopiado }}</span>
    </div>

    <div v-if="tab && itens.length > 0" class="eventoCompactoSelecao">
      <button type="button" @click="selecionarTodos()">Selecionar todos</button>
      <button type="button" @click="limparSelecionados(true)">Limpar</button>
    </div>

    <template v-for="item in eventosRenderizados">
      <div
        v-if="item.__grupo"
        :key="item.__grupoKey"
        class="eventoCompactoGrupo"
      >
        {{ item.nome }}
      </div>

      <div
        v-else
        :key="item._id || item.id"
        class="eventoCompactoLinha"
        :class="{ eventoCompactoLinhaSelecionada: item.selecionado }"
      >
        <label
          v-if="retornaSite() !== 'Share'"
          class="eventoCompactoCheckbox"
          title="Selecionar evento"
        >
          <input
            v-model="item.selecionado"
            type="checkbox"
            @change="$emit('selecionar', $event, item)"
          />
        </label>
        <span v-else class="eventoCompactoCheckbox" aria-hidden="true"></span>

        <div class="eventoCompactoIdentidade">
          <div class="eventoCompactoTitulo">
            <time v-if="retornaSite() !== 'Share'">
              {{ item.dataHora.toString().padStart(2, "0") }}:{{
                item.dataMinuto.toString().padStart(2, "0")
              }}
            </time>
            <strong>{{ item.nome }}</strong>
          </div>

          <div v-if="retornaSite() !== 'Share'" class="eventoCompactoMeta">
            <span
              class="eventoCompactoSituacao"
              :class="'eventoCompactoSituacao' + item.situacao"
            >
              {{ situacao[item.situacao] }}
            </span>
            <span
              v-if="
                retornaSite() == 'Weddbets' &&
                item.usuarioCriacaoJoin &&
                item.usuarioCriacaoJoin.length > 0
              "
            >
              {{ item.usuarioCriacaoJoin[0].nome }}
            </span>
            <span
              v-if="
                $global.servidores_sip()[
                  item.servidorTipo + '_' + item.servidor
                ]
              "
              class="eventoCompactoServidor"
            >
              {{
                $global.servidores_sip()[
                  item.servidorTipo + "_" + item.servidor
                ].nome
              }}
              <template
                v-if="
                  retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp'
                "
              >
                ({{ item.canais }})
              </template>
            </span>
            <span class="eventoCompactoSource" :title="sourceEventoLabel(item)">
              {{ sourceEventoLabel(item) }}
            </span>
          </div>

          <div
            v-else-if="
              item.usuarioCriacaoJoin && item.usuarioCriacaoJoin.length > 0
            "
            class="eventoCompactoMeta"
          >
            {{ item.usuarioCriacaoJoin[0].email }}
          </div>
        </div>

        <div
          v-if="retornaSite() !== 'Share'"
          class="eventoCompactoIntegracoes"
        >
          <svg
            class="eventoCompactoStatusIcone"
            :class="{
              eventoCompactoStatusTransmitindo: eventoTransmitindo(item),
            }"
            viewBox="0 0 16 16"
            fill="currentColor"
            :title="
              eventoTransmitindo(item)
                ? 'Transmissao ativa'
                : 'Transmissao inativa'
            "
            role="img"
            :aria-label="
              eventoTransmitindo(item)
                ? 'Transmissao ativa'
                : 'Transmissao inativa'
            "
          >
            <path
              fill-rule="evenodd"
              d="M0 5a2 2 0 0 1 2-2h7.5a2 2 0 0 1 1.983 1.738l3.11-1.382A1 1 0 0 1 16 4.269v7.462a1 1 0 0 1-1.406.913l-3.111-1.382A2 2 0 0 1 9.5 13H2a2 2 0 0 1-2-2V5z"
            />
          </svg>
          <svg
            v-if="eventoTemAgendamento(item)"
            class="eventoCompactoStatusIcone eventoCompactoStatusAgendado"
            viewBox="0 0 16 16"
            fill="currentColor"
            title="Transmissao automatica agendada"
            role="img"
            aria-label="Transmissao automatica agendada"
          >
            <path
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 3.5a.5.5 0 0 0-1 0V9a.5.5 0 0 0 .252.434l3.5 2a.5.5 0 0 0 .496-.868L8 8.71V3.5z"
            />
          </svg>

          <button
            type="button"
            class="eventoCompactoTag"
            :class="{ eventoCompactoTagAtiva: item.sofaScoreId }"
            data-target="#dialogEdit"
            data-toggle="modal"
            @click="$emit('editarItem', item._id)"
          >
            SOFA
          </button>
          <button
            type="button"
            class="eventoCompactoTag"
            :class="{ eventoCompactoTagAtiva: item.williamHillId }"
            @click="$emit('williamhillVincular', item._id)"
          >
            WILL
          </button>
          <button
            v-if="
              retornaSite() == '7live' &&
              item.usuarioCriacaoJoin &&
              item.usuarioCriacaoJoin.length > 0
            "
            type="button"
            class="eventoCompactoTag"
            :class="{
              eventoCompactoTagAtiva:
                item.usuarioCriacaoJoin[0]._id == idUsuario,
            }"
            data-target="#dialogEdit"
            data-toggle="modal"
            @click="$emit('editarItem', item._id)"
          >
            {{ item.usuarioCriacaoJoin[0].nome }}
          </button>
        </div>

        <div class="eventoCompactoAcoes">
          <button
            type="button"
            class="eventoCompactoBotao eventoCompactoBotaoNeutro"
            data-target="#dialogEdit"
            data-toggle="modal"
            @click="$emit('editarItem', item._id)"
          >
            Editar
          </button>
          <button
            type="button"
            class="eventoCompactoBotao eventoCompactoBotaoPrincipal"
            @click="$emit('transmitItem', item._id)"
          >
            Transmitir
          </button>

          <div class="eventoCompactoMenu">
            <button
              type="button"
              class="eventoCompactoMais"
              title="Mais acoes"
              aria-label="Mais acoes"
              :aria-expanded="menuAbertoId === item._id ? 'true' : 'false'"
              @click.stop="alternarMenu(item._id)"
            >
              <svg viewBox="0 0 16 16" fill="currentColor" aria-hidden="true">
                <circle cx="3" cy="8" r="1.5" />
                <circle cx="8" cy="8" r="1.5" />
                <circle cx="13" cy="8" r="1.5" />
              </svg>
            </button>

            <div
              v-if="menuAbertoId === item._id"
              class="eventoCompactoMenuLista"
            >
              <button
                v-if="item.situacao == 1"
                type="button"
                @click="
                  menuAbertoId = null;
                  $emit('aoVivo', item._id);
                "
              >
                Colocar ao vivo
              </button>
              <button
                v-if="
                  retornaSite() == 'Weddbets' || retornaSite() == 'ShareApp'
                "
                type="button"
                @click="alternarCanais(item)"
              >
                Canais
              </button>
              <button
                type="button"
                @click="
                  menuAbertoId = null;
                  abrirEventoPlayer(item, 1);
                "
              >
                Player
              </button>
              <button
                v-if="retornaSite() !== '7live'"
                type="button"
                @click="
                  menuAbertoId = null;
                  copyId(item._id);
                "
              >
                Copiar ID
              </button>
              <button
                type="button"
                class="eventoCompactoMenuPerigo"
                @click="
                  menuAbertoId = null;
                  $emit('excluirItem', item);
                "
              >
                Excluir
              </button>
              <button
                v-if="item.situacao == 3"
                type="button"
                @click="
                  menuAbertoId = null;
                  $emit('encerrar', item._id);
                "
              >
                Encerrar
              </button>
            </div>
          </div>
        </div>

        <div
          v-if="listViewFuncoes[item._id] === 'player'"
          class="eventoCompactoCanais"
        >
          <span>Canal</span>
          <button
            v-for="(canal, keyCanal) in [
              1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18,
              19, 20, 21,
            ]"
            :key="keyCanal"
            type="button"
            @click="abrirEventoPlayer(item, keyCanal)"
          >
            {{ keyCanal }}
          </button>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import ListEventos from "./ListEventos.vue";

export default {
  name: "ListEventosCompacto",
  extends: ListEventos,
  data: function () {
    return {
      menuAbertoId: null,
    };
  },
  methods: {
    alternarMenu(itemId) {
      this.menuAbertoId = this.menuAbertoId === itemId ? null : itemId;
    },
    alternarCanais(item) {
      this.menuAbertoId = null;
      this.alterarListViewFuncoes(item);
    },
  },
};
</script>

<style scoped>
.eventosCompactos {
  color: #212529;
  position: relative;
}

.eventoCompactoAviso {
  align-items: center;
  background: #e9ecef;
  border-left: 3px solid #495057;
  display: flex;
  font-size: 11px;
  gap: 6px;
  margin-bottom: 6px;
  padding: 5px 8px;
}

.eventoCompactoSelecao {
  display: flex;
  gap: 4px;
  margin-bottom: 5px;
}

.eventoCompactoSelecao button {
  background: #fff;
  border: 1px solid #ced4da;
  border-radius: 2px;
  color: #495057;
  font-size: 10px;
  height: 22px;
  padding: 0 7px;
}

.eventoCompactoGrupo {
  background: #f1f3f5;
  border-left: 3px solid #495057;
  color: #343a40;
  font-size: 11px;
  font-weight: 600;
  margin-top: 7px;
  padding: 5px 8px;
  text-align: left;
}

.eventoCompactoLinha {
  align-items: center;
  background: #fff;
  border: 1px solid #dee2e6;
  border-top: 0;
  display: grid;
  gap: 10px;
  grid-template-columns: 18px minmax(250px, 1fr) auto auto;
  min-height: 52px;
  padding: 6px 8px;
  position: relative;
}

.eventoCompactoLinha:first-of-type {
  border-top: 1px solid #dee2e6;
}

.eventoCompactoLinhaSelecionada {
  background: #f4f8fc;
  box-shadow: inset 3px 0 #0d6efd;
}

.eventoCompactoCheckbox {
  align-items: center;
  display: flex;
  height: 18px;
  justify-content: center;
  margin: 0;
  width: 18px;
}

.eventoCompactoCheckbox input {
  height: 14px;
  margin: 0;
  width: 14px;
}

.eventoCompactoIdentidade {
  min-width: 0;
  text-align: left;
}

.eventoCompactoTitulo {
  align-items: baseline;
  display: flex;
  gap: 6px;
  line-height: 1.2;
  min-width: 0;
}

.eventoCompactoTitulo time {
  color: #495057;
  flex: 0 0 auto;
  font-size: 12px;
  font-variant-numeric: tabular-nums;
}

.eventoCompactoTitulo strong {
  font-size: 13px;
  font-weight: 500;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eventoCompactoMeta {
  align-items: center;
  color: #6c757d;
  display: flex;
  font-size: 9px;
  gap: 6px;
  line-height: 1.2;
  margin-top: 3px;
  min-width: 0;
}

.eventoCompactoMeta > span:not(:last-child)::after {
  color: #ced4da;
  content: "/";
  margin-left: 6px;
}

.eventoCompactoSituacao {
  font-weight: 600;
}

.eventoCompactoSituacao1 {
  color: #495057;
}

.eventoCompactoSituacao2 {
  color: #6c757d;
}

.eventoCompactoSituacao3 {
  color: #198754;
}

.eventoCompactoSituacao4 {
  color: #6c757d;
}

.eventoCompactoServidor {
  color: #198754;
}

.eventoCompactoSource {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.eventoCompactoIntegracoes,
.eventoCompactoAcoes {
  align-items: center;
  display: flex;
}

.eventoCompactoIntegracoes {
  gap: 4px;
}

.eventoCompactoTag {
  background: #fff;
  border: 1px solid #6c757d;
  border-radius: 2px;
  color: #495057;
  font-size: 9px;
  height: 20px;
  line-height: 1;
  padding: 0 5px;
}

.eventoCompactoTagAtiva {
  background: #343a40;
  border-color: #343a40;
  color: #fff;
}

.eventoCompactoStatusIcone {
  color: #868e96;
  flex: 0 0 14px;
  height: 14px;
  width: 14px;
}

.eventoCompactoStatusTransmitindo {
  color: #198754;
}

.eventoCompactoStatusAgendado {
  color: #f59e0b;
}

.eventoCompactoAcoes {
  gap: 4px;
  justify-content: flex-end;
}

.eventoCompactoBotao,
.eventoCompactoMais {
  border-radius: 2px;
  font-size: 9px;
  height: 22px;
  line-height: 1;
}

.eventoCompactoBotao {
  padding: 0 7px;
  white-space: nowrap;
}

.eventoCompactoBotaoNeutro {
  background: #fff;
  border: 1px solid #adb5bd;
  color: #343a40;
}

.eventoCompactoBotaoPrincipal {
  background: #0d6efd;
  border: 1px solid #0d6efd;
  color: #fff;
}

.eventoCompactoMenu {
  position: relative;
}

.eventoCompactoMais {
  align-items: center;
  background: #fff;
  border: 1px solid #adb5bd;
  color: #495057;
  display: flex;
  justify-content: center;
  padding: 0;
  width: 24px;
}

.eventoCompactoMais svg {
  height: 14px;
  width: 14px;
}

.eventoCompactoMenuLista {
  background: #fff;
  border: 1px solid #ced4da;
  box-shadow: 0 3px 8px rgba(33, 37, 41, 0.16);
  min-width: 126px;
  padding: 3px 0;
  position: absolute;
  right: 0;
  top: 25px;
  z-index: 20;
}

.eventoCompactoMenuLista button {
  background: #fff;
  border: 0;
  color: #343a40;
  display: block;
  font-size: 10px;
  padding: 5px 9px;
  text-align: left;
  width: 100%;
}

.eventoCompactoMenuLista button:hover {
  background: #f1f3f5;
}

.eventoCompactoMenuLista .eventoCompactoMenuPerigo {
  color: #dc3545;
}

.eventoCompactoCanais {
  align-items: center;
  border-top: 1px solid #e9ecef;
  display: flex;
  flex-wrap: wrap;
  gap: 3px;
  grid-column: 2 / -1;
  padding-top: 5px;
}

.eventoCompactoCanais span {
  color: #6c757d;
  font-size: 9px;
  margin-right: 3px;
}

.eventoCompactoCanais button {
  background: #fff;
  border: 1px solid #adb5bd;
  border-radius: 2px;
  color: #0d6efd;
  font-size: 9px;
  height: 20px;
  min-width: 23px;
  padding: 0 4px;
}

button:hover {
  filter: brightness(0.96);
}

button:focus-visible,
input:focus-visible {
  outline: 2px solid #80bdff;
  outline-offset: 1px;
}

@media (max-width: 767px) {
  .eventoCompactoLinha {
    gap: 6px;
    grid-template-columns: 18px minmax(0, 1fr) auto;
  }

  .eventoCompactoIntegracoes {
    grid-column: 2;
  }

  .eventoCompactoAcoes {
    grid-column: 3;
    grid-row: 1 / span 2;
  }

  .eventoCompactoMeta {
    flex-wrap: wrap;
  }
}

@media (max-width: 540px) {
  .eventoCompactoLinha {
    grid-template-columns: 18px minmax(0, 1fr);
  }

  .eventoCompactoAcoes {
    grid-column: 2;
    grid-row: auto;
    justify-content: flex-start;
  }

  .eventoCompactoIntegracoes {
    grid-column: 2;
  }
}
</style>
